import React, {useContext, useEffect, useState} from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { NonaGrayImg } from '../../assets/images/images'
import mainContext from '../../contexts/mainContext'
import { getStripeRefreshLink } from '../../Controllers/stripe'
import Loader from '../Loader/Loader'
import './stripe.css'

export default function RefreshUrl() {
    const { setPageload, pageload } = useContext(mainContext);
    const navigate = useNavigate()
    const [state, setState] = useState({
        msg: "",
        error: "",
        link: null
    })

    useEffect(() => {
        async function fetchRefreshLink() {
            let query = new URLSearchParams(window.location.search)
            let accountId = query.get("acc")
            let token = query.get("auth")
        
            const res = await getStripeRefreshLink(accountId, token)
            if (res.data.status === 200) {
                setState({ msg: "Please continue to onBoarding process.", error: null, link: res.data.data.accountLink.url })
            } else {
                setState({ msg: null, error: res.data.errors[0].message })
            }
            setPageload(false)
        }
        setPageload(true)
        fetchRefreshLink()
        return () => { }
    }, [])



    return (
        <React.Fragment>
            <div className="stripe">
                <div className="container">
                    <section className='logo'>
                        <img src={NonaGrayImg} alt="" />
                    </section>
                    <section>
                        <h3 className={"error-text"}>{state.error}</h3>
                        <h3 className={"success-text"}>{state.msg} <small><a href={state.link}>Click here</a></small></h3>
                    </section>
                    <section className='btn-sec'>
                        <button className='return-app' onClick={() => navigate(-1)}>Return to Nona</button>
                    </section>
                </div>
            </div>
            <Loader type='fullpage' open={pageload} />
        </React.Fragment>
    )
}


